/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/
import { useContext } from "react";
import { UseHandlerContext, UseStateContext } from "./TabContainer";

type useTabType = {
	currentId: string;
	uiType: DesignStuff.Tabs.uiType;
	currentState: { left: number; width: number };
	allActive?: boolean;
	handleSelectTab: DesignStuff.Tabs.SelectHandler<string>;
	handleItemScroll: ({
		scrollTargetID,
		type
	}:
		| {
				scrollTargetID: string;
				type: "create";
		  }
		| {
				scrollTargetID: string;
				type: "delete";
		  }
		| {
				scrollTargetID: string;
				type: "select";
				index: number;
		  }) => void;
};

export default function useTab(): useTabType {
	const { currentId, uiType = "normal", currentState, allActive } = useContext(UseStateContext);

	const handleSelectTab = useContext(UseHandlerContext);

	const handleItemScroll = ({
		scrollTargetID,
		type,
		index = 0
	}: {
		scrollTargetID: string;
		type: "create" | "delete" | "select";
		index?: number;
	}) => {
		const target = document.getElementById(scrollTargetID) as HTMLDivElement;
		const tabItemElement = target.querySelector("ul")?.childNodes[index] as HTMLLIElement;
		const xScrollPos =
			type === "select" ? tabItemElement.offsetLeft : tabItemElement.clientWidth + tabItemElement.offsetLeft;

		target.scrollTo({
			behavior: "smooth",
			left: type === "delete" ? 0 : xScrollPos
		});
	};

	if (!handleSelectTab) throw new Error("not found UseHandlerContext");

	return { currentId, currentState, uiType, allActive, handleSelectTab, handleItemScroll };
}
